import axios from "axios";

export const getUser = async ({ requestUser }) => {
    try {
      const res = await axios.post(
        `https://production.carnot-traclytics.com/fleet/analytics_login/`,
        { username:requestUser.username, password: requestUser.password }
      );
      return res.data;
    } catch (err) {
      throw err;
    }
  };